import EditModal from '../EditUser/Button';
const displayData = (props) => {
    const {subscribersData, columns, handleShowUserInfo, fetchList, domain, regions} = props;

    function isNullOrEmpty(str) {
        // const star =
        return str?.replace(/\s+/g, '')
        // star === "" || star === null;
    }   

    return subscribersData.users && subscribersData.users.map(row => (
        <tr key={row.user_id} >
            {columns.map(column => {
                if(column.id === "btn") {
                    return <td key={column.id} style={{width: 40}}><EditModal id={row.user_id} fetchList={fetchList} domain={domain} regions={regions}/></td>
                } else if(column.id === "user_id"){
                    return <td onClick={() => {handleShowUserInfo(row.user_id, row.email)}} key={column.id} style={{width: 120}}>{row.user_id}</td>
                }else {
                    return <td onClick={() => {handleShowUserInfo(row.user_id, row.email)}} key={column.id}> {isNullOrEmpty(row[column.id]) ?  row[column.id] : 'None'} </td> 
                }
            })}
        </tr>
    ));
} 

export default displayData;